import React from "react";
import {
  Flex,
  PageContent,
  PageHeadingArea,
  PageTitle,
  ResponsiveLayoutWrapper,
  Root,
} from "@backslashbuild/contractors-ui-library";

import NavBar from "../components/NavBar";
import ContractorTopBar from "../modules/contractors/ContractorTopBar";
import ContractorLoginDetailsForm from "../modules/contractors/ContractorLoginDetailsForm";
import AcceptContractDialog from "../modules/contractors/AcceptContractDialog";
import PageFooter from "../components/PageFooter";

function EditLoginDetails() {
  return (
    <Root>
      <PageContent scrollable>
        <ContractorTopBar />
        <NavBar />
        <PageHeadingArea>
          <PageTitle>Edit login details</PageTitle>
        </PageHeadingArea>
        <ResponsiveLayoutWrapper>
          <ContractorLoginDetailsForm />
        </ResponsiveLayoutWrapper>
        <Flex></Flex>
        <PageFooter />
      </PageContent>
      <AcceptContractDialog />
    </Root>
  );
}

export default EditLoginDetails;
